import StringTypeRen from "csi/heading/StringType";
import reflection from "csi/reflection";
import declare from "dojo/_base/declare";
import Classes from "csi/store/Classes";
import InlineSelect from "csi/widget/InlineSelect";

const ActivityLevelRenderer = declare(StringTypeRen, {
	/**
     * @override
     * Overrides the toHtmlQueryFilter method to hard code in the Calendar Level classes that should show on the view filter
     */
	toHtmlQueryFilter(ctx, spec, refNode, params) {
		const classOptions = reflection.getClass("CalendarContainer").getConcreteClasses();

		params.store = Classes(classOptions);

		return new InlineSelect(params);
	},
});

export = ActivityLevelRenderer;
